module.exports = __webpack_public_path__ + "static/media/bonito.986ad8cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/bonito.png
// module id = 305
// module chunks = 0